import $ from "jquery";

function swapChildren(obj1, obj2)
{
    var temp = obj2.children().detach();
    obj2.empty().append(obj1.children().detach());
    obj1.append(temp);
}

$(document).ready(function() {
    /*if (!prestashop.responsive.mobile && ($("body").innerHeight() >= ($(window).innerHeight() + 300))) {
        let scroll = $(window).scrollTop();
        let headerTopHeight = $('#header > .header-top').innerHeight();
        toggleFixedHeader(scroll <= headerTopHeight);
    }
    $(document).on('scroll', function() {
        if (!prestashop.responsive.mobile && ($("body").innerHeight() >= ($(window).innerHeight() + 300) || $('#header').hasClass('fixed'))) {
            let scroll = $(window).scrollTop();
            let headerTopHeight = $('#header > .header-top').innerHeight();
            toggleFixedHeader(scroll <= headerTopHeight);
        }
    });*/

    var headerTopPos = $('header#header').outerHeight();
    var headerTopOffset = $('header#header').offset().top;
    changeHeaderScroll(headerTopPos,headerTopOffset);

    $( window ).scroll(function() {
        changeHeaderScroll(headerTopPos,headerTopOffset);
    });

    prestashop.on('responsive update', function( event ) {
        console.log('RESPONSIVE DONE');
        $('body').css('padding-top','');
        $('header#header').removeClass('sticky').css('transform', '');
        $('header#header').find('.infraheadertext, .header-banner, .header-nav').css({
            'position': '',
            'bottom': ''
        });
        headerTopPos = $('header#header').outerHeight();
        headerTopOffset = $('header#header').offset().top;
        changeHeaderScroll(headerTopPos,headerTopOffset);
    });
    $( window ).resize(function() {
        $('body').css('padding-top','');
        $('header#header').removeClass('sticky').css('transform', '');
        $('header#header').find('.infraheadertext, .header-banner, .header-nav').css({
            'position': '',
            'bottom': ''
        });
        $("*[id^='_fixed_']").each(function(idx, el) {
            var target = $('#' + el.id.replace('_fixed_', '_desktop_'));
            if (target.length) {
                var temp = $(el).children().detach();
                target.append(temp);
            }
        });
        headerTopPos = $('header#header').outerHeight();
        headerTopOffset = $('header#header').offset().top;
        changeHeaderScroll(headerTopPos,headerTopOffset);
    });
});

function changeHeaderScroll(headerTopPos, headerTopOffset) {
    if ($('body').is('#checkout')) {
        return false;
    }

    if($(window).width() >= 992) {
        if ($(window).scrollTop() > headerTopPos + headerTopOffset) {
            if ($('header#header').hasClass('sticky')) {
                return;
            }
            $('header#header').addClass('sticky');
            $('header#header').css('transform', 'translateY(100%)');

            $('body').css({
                'padding-top': headerTopPos,
                'min-height': '100%'
            });

            $("*[id^='_fixed_']").each(function(idx, el) {
                var target = $('#' + el.id.replace('_fixed_', '_desktop_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });

        } else if ($(window).scrollTop() <= headerTopPos) {
            if (!$('header#header').hasClass('sticky')) {
                return;
            }
            if ($(window).scrollTop() + $('#header').outerHeight() <= headerTopPos + headerTopOffset ) {
                $('header#header').removeClass('sticky');
                $('header#header').css('transform', '');
                $('body').css('padding-top', '');
                $("*[id^='_desktop_']").each(function(idx, el) {
                    var target = $('#' + el.id.replace('_desktop_', '_fixed_'));
                    if (target.length) {
                        swapChildren($(el), target);
                    }
                });
            }
        }
    } else {
        $('header#header').css('transform', '');
        $('body').css({
            'padding-top': $('header#header .header-wrapper').outerHeight()
        });
    }
}



// WEBPACK FOOTER //
// ./js/fixed-header.js